import * as changeCaseObject from 'change-case-object';

import { stringify } from 'qs';

export class Api {
  options: object;
  baseUrl: string;
  timeout: number;

  constructor(baseUrl: string, timeout = 10000) {
    this.baseUrl = baseUrl;
    this.timeout = timeout;
  }

  get headers() {
    return new Headers({
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    });
  }

  get(url: string, options = { headers: new Headers(), params: {} }) {
    const stringifiedParams = stringify(changeCaseObject.snakeCase(options.params));
    const requestUrl = url + (stringifiedParams ? '?' + stringifiedParams : '');
    return this.fetch(this.baseUrl + requestUrl, {
      headers: options.headers,
      method: 'GET'
    });
  }

  post(url: string, options = {}) {
    return this.fetch(this.baseUrl + url, {
      method: 'POST',
      ...options
    });
  }

  patch(url: string, options = {}) {
    return this.fetch(this.baseUrl + url, {
      method: 'PATCH',
      ...options
    });
  }

  delete(url: string, options = {}) {
    return this.fetch(this.baseUrl + url, {
      method: 'DELETE',
      ...options
    });
  }

  private fetch(url: string, init: RequestInit): Promise<any> {
    const body = this.normalizeRequestBody(init.body);
    const headers = init.headers || this.headers;
    const method = init.method;
    const options = { ...this.options, body, headers, method };

    return this.fetch$(url, options)
      .then(this.modifyResponse);
  }

  private fetch$(input: RequestInfo, opts: RequestInit) {
    return new Promise((resolve, reject) => {
      setTimeout(reject, this.timeout);
      fetch(input, opts).then(resolve, reject);
    });
  }

  private normalizeRequestBody(body: any) {
    if (body instanceof FormData || typeof body === 'string') {
      return body;
    }

    return JSON.stringify(changeCaseObject.snakeCase(body));
  }

  private modifyResponse(response: Response) {
    return response.text().then((text) => {
      const json = text ? changeCaseObject.camelCase(JSON.parse(text)) : {};
      if (response.status >= 200 && response.status < 300) {
        return json;
      }

      const newError = new Error(response.statusText);
      throw {
        ...newError,
        body: json,
        status: response.status
      };
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/api/base.ts